module.exports = __webpack_public_path__ + "img/rightPink.b1e5d20c.svg";